import React from 'react';
import _ from 'lodash';
import { Link } from 'react-router-dom';
import { SvgIcon } from 'core/icons';
import { BYO_CLOSE, dispatchCustomEvent } from '../../../utils/customMessage';
import { TranslateHTML } from 'core/translate';

const getTopSortedOptions = (options) => {
  const sorted = _.sortBy(options, 'id');
  return _.take(sorted, 4);
};

const PackageOptionsList = ({
  id,
  options,
  analyticsKey,
  analyticsKey2,
  showAllOptions,
}) => {
  if (options && options.length === 0) {
    return null;
  }

  const sortedOptions = getTopSortedOptions(options);
  const count = options && options.length;
  const listItems = sortedOptions.map((option) => {
    const MAX_LENGTH = 72;
    const { description, code } = option;
    const truncatedDescription = () => {
      return description && description.length > MAX_LENGTH
        ? `${description.substring(0, MAX_LENGTH)}&hellip;`
        : description;
    };

    return (
      <div
        key={code}
        dangerouslySetInnerHTML={{ __html: truncatedDescription() }}
        className="package-list__description"
      />
    );
  });

  const onClick = (event) => {
    event.stopPropagation();
    dispatchCustomEvent(BYO_CLOSE);
  };

  return (
    <div className="package-list-container">
      {showAllOptions ? (
        listItems
      ) : (
        <>
          {listItems.slice(0, 3)}
          <div className="package-list__link-container" onClick={onClick}>
            <Link
              to={`package/${id}`}
              className="package-list__link stat-text-link"
              data-dtm={analyticsKey}
              data-dtm2={analyticsKey2}>
              <TranslateHTML
                className="package-list__more-label"
                value={`${
                  !showAllOptions && count > 3
                    ? 'show.all.features.v3'
                    : 'show.feature.details.v3'
                }`}
              />
              <SvgIcon
                name="packages-more"
                className="package-list__link-svg"
              />
            </Link>
          </div>
        </>
      )}
    </div>
  );
};

export default PackageOptionsList;
